// Toast 訊息 composable。狀態宣告在模組層級，故所有呼叫端共用同一個佇列（單例）；
// useToast() 只是回傳這份共用狀態的存取器。postMessage 推入後 5 秒自動移除。
import { reactive } from 'vue';

const toastsMessages = reactive([]);

function postMessage(type, title, message) {
  const object = {
    statusBg: type === 'danger' ? 'bg-danger' : 'bg-success',
    statusColor: ' text-white',
    title,
    message,
  };
  toastsMessages.push(object);
  setTimeout(() => {
    toastsMessages.shift();
  }, 5000);
}

export function useToast() {
  return { toastsMessages, postMessage };
}
